var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "panel",
    style: _vm.panelStyles
  }, [_c('div', {
    staticStyle: {
      "padding-top": "1px",
      "padding-bottom": "1px"
    }
  }, [_c('div', {
    ref: "inner",
    staticStyle: {
      "margin-top": "-1px",
      "margin-bottom": "-1px"
    },
    style: _vm.innerStyles
  }, [_vm.loadContents || _vm.forceRender ? _vm._t("default", null, {
    "isClosing": _vm.isClosing,
    "isOpening": _vm.isOpening
  }) : _vm._e()], 2)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }